export enum ProofOfPaymentType {
  PAYMENT_CONFIRMATION = 'PAYMENT_CONFIRMATION',
  DETAILED_PAYMENT_CONFIRMATION = 'DETAILED_PAYMENT_CONFIRMATION',
  COMPROVANTE_OPERACAO = 'COMPROVANTE_OPERACAO',
  NONE = '',
}
